/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

(function () {

  function updateConsentText(shadow) {

    const emailSpan = shadow.querySelector('#emailConsent-true-label span');

    if (emailSpan && !emailSpan.dataset.customized) {
      emailSpan.dataset.customized = 'true';

      emailSpan.innerHTML = `
        <p style="font-size: 12px; line-height: 18px;">By providing your email and checking this box, you agree to receive promotional and personalized marketing emails from Twinings, including product news, offers, and cart reminders, at the email address used when signing up. You can unsubscribe at any time via the link in our emails or by contacting
        <a style="color:#fff;" href="mailto:consumer.service@twiningsusa.com">consumer.service@twiningsusa.com</a>.
        View
        <a style="color:#fff;" href="https://twiningsusa.com/pages/terms-of-use" target="_blank" rel="noopener noreferrer">Terms</a>
        and
        <a style="color:#fff;" href="https://twiningsusa.com/pages/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
      </p>`;
    }

    const smsSpan = shadow.querySelector('#phoneConsent-true-label span');

    if (smsSpan && !smsSpan.dataset.customized) {
      smsSpan.dataset.customized = 'true';

      smsSpan.innerHTML = `
        <p style="font-size: 12px; line-height: 18px;">By providing your phone number and checking this box, you agree to receive recurring automated promotional and personalized marketing text messages (e.g., cart reminders) from Twinings at the cell number used when signing up. Consent is not a condition of purchase. For help email
        <a style="color:#fff;" href="mailto:consumer.service@twiningsusa.com">consumer.service@twiningsusa.com</a>
        or call 1-800-803-6695. Reply STOP to cancel. Msg frequency varies. Msg and data rates may apply. View
        <a style="color:#fff;" href="https://twiningsusa.com/pages/terms-of-use" target="_blank" rel="noopener noreferrer">Terms</a>
        and
        <a style="color:#fff;" href="https://twiningsusa.com/pages/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
      </p>`;
    }
  }

  function init() {
    const host = document.querySelector('shopify-forms-embed');

    if (!host || !host.shadowRoot) {
      requestAnimationFrame(init);
      return;
    }

    const shadow = host.shadowRoot;

    updateConsentText(shadow);

    new MutationObserver(() => {
      updateConsentText(shadow);
    }).observe(shadow, {
      childList: true,
      subtree: true
    });
  }

  init();

})();
